import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useHistory} from 'react-router-dom'
import {toast} from 'react-toastify'
import {shallowEqual, useSelector} from 'react-redux'
import {
  IExpenseMasterModel,
  expenseMasterInitValues as initialValues,
  IExpensedTypeDropDown,
  ITypeDropDown,
} from '../../../models/expense/ExpenseMasterModel'
import {UserModel} from '../../../modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
import {
  createExpense,
  getExpenseTypeDropDown,
  getTypeBusinessDropDown,
} from '../../../modules/expense_page/ExpenseMasterCRUD'

const profileDetailsSchema = Yup.object().shape({
  bTransTypeID: Yup.number().required('Type is Required').min(1, 'Type is Required'),
  expenseTypeID: Yup.number()
    .required('Expense Type is Required')
    .min(1, 'Expense Type is Required'),
  amount: Yup.number().required('Amount is Required').min(1, 'Amount is Required'),
  transactionDate: Yup.string().required('Transaction Date is Required'),
  descriptions: Yup.string().required('Descriptions is Required'),
  expenseTitle: Yup.string().required('Title is Required'),
})

interface ICity {
  loading: boolean
  expenseTypeData: IExpensedTypeDropDown[]
  typeData: ITypeDropDown[]
}
const AddExpenseMaster: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [isActive, setIsActive] = useState(false)
  const [data, setData] = useState<IExpenseMasterModel>(initialValues)
  const updateData = (fieldsToUpdate: Partial<IExpenseMasterModel>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  const [allData, setAllData] = useState<ICity>({
    loading: false,
    expenseTypeData: [] as IExpensedTypeDropDown[],
    typeData: [] as ITypeDropDown[],
  })

  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  useEffect(() => {
    setAllData({...allData, loading: true})
    setTimeout(() => {
      getAllExpenseTypeDropDownData()
    }, 100)
  }, [])

  function getAllExpenseTypeDropDownData() {
    getExpenseTypeDropDown()
      .then((resp) => {
        const resExpTypeData = resp.data.responseObject
        getAllTypeDropDownData(resExpTypeData)
      })
      .catch((error) => {
        toast.error(`${error}`, {position: 'top-center'})
        setAllData({...allData, loading: false})
      })
  }

  function getAllTypeDropDownData(temExpTypData: IExpensedTypeDropDown[]) {
    getTypeBusinessDropDown()
      .then((resp) => {
        const resTypeData = resp.data.responseObject
        console.log(resTypeData)
        setAllData({
          ...allData,
          expenseTypeData: temExpTypData,
          typeData: resTypeData,
          loading: false,
        })
      })
      .catch((error) => {
        toast.error(`${error}`, {position: 'top-center'})
        setAllData({...allData, expenseTypeData: [], typeData: [], loading: false})
      })
  }

  const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    const elementId = event.target.id
    if (elementId === 'bTransTypeID') {
      formik.setFieldValue('bTransTypeID', parseInt(value))
    } else if (elementId === 'expenseTypeID') {
      formik.setFieldValue('expenseTypeID', parseInt(value))
    }
  }

  const formik = useFormik<IExpenseMasterModel>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(() => {
        createExpense(
          values.bTransTypeID,
          values.expenseTypeID,
          values.expenseTitle,
          values.descriptions,
          values.amount,
          values.transactionDate
        )
          .then((res) => {
            toast.success('Created Successfull', {position: 'top-center'})
            history.push('/expense/list')
            setLoading(false)
          })
          .catch((error) => {
            toast.error(`${error}`, {position: 'top-center'})
            setLoading(false)
          })
        // const updatedData = Object.assign(data, values)
        // setData(updatedData)
        setLoading(false)
      }, 1000)
    },
  })

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        {/* <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 ms-6'>Create Country </h3>
          </div>
        </div> */}
        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9 ms-6'>
              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Select Type:</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <select
                    className='form-select bg-light-primary'
                    aria-label='Default select example'
                    onChange={selectChange}
                    id='bTransTypeID'
                  >
                    <option selected value='0'>
                      Select Type
                    </option>
                    {allData.typeData.length > 0 &&
                      allData.typeData.map((data, index) => {
                        return (
                          <option key={index} value={data.bTransTypeID}>
                            {data.bTransTypeName}
                          </option>
                        )
                      })}
                  </select>
                  {formik.touched.bTransTypeID && formik.errors.bTransTypeID && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.bTransTypeID}</div>
                    </div>
                  )}
                </div>
              </div>
              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Select Expense Type:</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <select
                    className='form-select bg-light-primary'
                    aria-label='Default select example'
                    onChange={selectChange}
                    id='expenseTypeID'
                  >
                    <option selected value='0'>
                      Select Expense Type
                    </option>
                    {allData.expenseTypeData.length > 0 &&
                      allData.expenseTypeData.map((data, index) => {
                        return (
                          <option key={index} value={data.expenseTypeID}>
                            {data.expenseName}
                          </option>
                        )
                      })}
                  </select>
                  {formik.touched.expenseTypeID && formik.errors.expenseTypeID && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.expenseTypeID}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Title:</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter Title'
                    {...formik.getFieldProps('expenseTitle')}
                  />
                  {formik.touched.expenseTitle && formik.errors.expenseTitle && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.expenseTitle}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Desciption:</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter Desciption'
                    {...formik.getFieldProps('descriptions')}
                  />
                  {formik.touched.descriptions && formik.errors.descriptions && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.descriptions}</div>
                    </div>
                  )}
                </div>
              </div>
              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Amount:</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter Amount'
                    {...formik.getFieldProps('amount')}
                  />
                  {formik.touched.amount && formik.errors.amount && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.amount}</div>
                    </div>
                  )}
                </div>
              </div>
              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Date:</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <input
                    type='date'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter Date'
                    {...formik.getFieldProps('transactionDate')}
                  />
                  {formik.touched.transactionDate && formik.errors.transactionDate && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.transactionDate}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && 'Save'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export {AddExpenseMaster}
